import React, { useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import "./FaqCollapse.css";

function FaqCollapse({ question, children }) {
    const [clicked, setClicked] = useState(false)

    const handleClick = () => {
        setClicked(!clicked)
    }

    const findLink = (answer) => {
        if(/LINK TO CONTACT US/.test(answer) ){
            let newAnswer = answer.replace(/LINK TO CONTACT US/g, '')
            return {
                newAnswer,
                show: true
            }
        } else{
            return {newAnswer: answer}
        }
    }

    return (
        <div className="cards">
            <div className="faq__question-container">
                <title> lithonia pcp</title>
                <h4 className="faq__question"  onClick={handleClick}>Q: {question}</h4>
                <div className="arrows" onClick={handleClick} >
                    <title> lithonia pcp</title>
                    {clicked ? <FaAngleUp /> : <FaAngleDown />}
                </div>
            </div>
            {
                clicked
                    ? (
                        <div className="faq__answer-container">
                            <title> lithonia pcp</title>
                            <p className="faq__answer"><b>A:</b> {findLink(children).newAnswer} {findLink(children).show ? <Link id="contact-in-answer" to="contact">CONTACT US</Link> : null }</p>
                        </div>
                    )
                    : ''
            }

        </div>

    )
}

export default FaqCollapse